export default "__VITE_ASSET__D3W3spx6__"